/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Discount_Type_Form_Plan_DiscountInputs */

const en_admin_discount_type_form_plan_discount = /** @type {(inputs: Admin_Discount_Type_Form_Plan_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan Discount`)
};

const de_admin_discount_type_form_plan_discount = /** @type {(inputs: Admin_Discount_Type_Form_Plan_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarif-Rabatt`)
};

const es_admin_discount_type_form_plan_discount = /** @type {(inputs: Admin_Discount_Type_Form_Plan_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descuento automático del plan`)
};

const fr_admin_discount_type_form_plan_discount = /** @type {(inputs: Admin_Discount_Type_Form_Plan_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réduction sur le forfait`)
};

const nl_admin_discount_type_form_plan_discount = /** @type {(inputs: Admin_Discount_Type_Form_Plan_DiscountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnementskorting`)
};

/** @type {(inputs: Admin_Discount_Type_Form_Plan_DiscountInputs) => LocalizedString} */
const it_admin_discount_type_form_plan_discount = en_admin_discount_type_form_plan_discount;

/** @type {(inputs: Admin_Discount_Type_Form_Plan_DiscountInputs) => LocalizedString} */
const pt_br2_admin_discount_type_form_plan_discount = en_admin_discount_type_form_plan_discount;

/** @type {(inputs: Admin_Discount_Type_Form_Plan_DiscountInputs) => LocalizedString} */
const pl_admin_discount_type_form_plan_discount = en_admin_discount_type_form_plan_discount;

/** @type {(inputs: Admin_Discount_Type_Form_Plan_DiscountInputs) => LocalizedString} */
const hu_admin_discount_type_form_plan_discount = en_admin_discount_type_form_plan_discount;

/** @type {(inputs: Admin_Discount_Type_Form_Plan_DiscountInputs) => LocalizedString} */
const ro_admin_discount_type_form_plan_discount = en_admin_discount_type_form_plan_discount;

/**
* | output |
* | --- |
* | "Plan Discount" |
*
* @param {Admin_Discount_Type_Form_Plan_DiscountInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_discount_type_form_plan_discount = /** @type {((inputs?: Admin_Discount_Type_Form_Plan_DiscountInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Discount_Type_Form_Plan_DiscountInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_discount_type_form_plan_discount(inputs)
	if (locale === "de") return de_admin_discount_type_form_plan_discount(inputs)
	if (locale === "es") return es_admin_discount_type_form_plan_discount(inputs)
	if (locale === "fr") return fr_admin_discount_type_form_plan_discount(inputs)
	if (locale === "nl") return nl_admin_discount_type_form_plan_discount(inputs)
	if (locale === "it") return it_admin_discount_type_form_plan_discount(inputs)
	if (locale === "pt-BR") return pt_br2_admin_discount_type_form_plan_discount(inputs)
	if (locale === "pl") return pl_admin_discount_type_form_plan_discount(inputs)
	if (locale === "hu") return hu_admin_discount_type_form_plan_discount(inputs)
	return ro_admin_discount_type_form_plan_discount(inputs)
});
export { admin_discount_type_form_plan_discount as "admin.discount_type_form.plan_discount" }